import { Builder } from '@builder.io/react';
import dynamic from 'next/dynamic';
import { Icon } from '#const';
import { getIconUrl } from '#utils';

const BragBarV2 = dynamic(() => import('./BragBarV2'));

/** CDN-hosted trust indicator icons (consultation, clients, confidential) for Builder.io defaults */
const BRAG_BAR_DEFAULT_ICONS = {
	consultation:
		'https://cdn.builder.io/api/v1/image/assets%2F039564790efd46a2bd9966880285bc7f%2F990e612a25d947a8b18fb4b71b5a1471',
	clients:
		'https://cdn.builder.io/api/v1/image/assets%2F039564790efd46a2bd9966880285bc7f%2F3fb3de19692543c4bfcd12edd5bef886',
	confidential:
		'https://cdn.builder.io/api/v1/image/assets%2F039564790efd46a2bd9966880285bc7f%2F464894c5e6c34361bd9cceff19f01914',
} as const;

export const defaultOptions = {
	items: [
		{ text: '100% Free Consultation', icon: BRAG_BAR_DEFAULT_ICONS.consultation },
		{ text: '80,000+ Clients Served', icon: BRAG_BAR_DEFAULT_ICONS.clients },
		{ text: 'Confidential & Encrypted', icon: BRAG_BAR_DEFAULT_ICONS.confidential },
	],
	backgroundColor: 'rgba(255,255,255, 1)',
	borderColor: 'rgba(243, 244, 246, 1)',
	textColor: 'rgba(71, 85, 105, 1)',
	textSizeMobile: 0.625,
	textSizeDesktop: 0.75,
} as const;

Builder.registerComponent(BragBarV2, {
	name: 'BragBarV2',
	inputs: [
		{
			name: 'items',
			friendlyName: 'Items',
			type: 'list',
			defaultValue: [...defaultOptions.items],
			subFields: [
				{
					name: 'icon',
					friendlyName: 'Image',
					type: 'file',
					helperText: 'Prefer using SVG for icons',
					allowedFileTypes: ['jpeg', 'jpg', 'png', 'svg', 'gif', 'webp'],
				},
				{
					name: 'text',
					friendlyName: 'Text',
					type: 'string',
				},
			],
			onChange: function (options) {
				if (options.get('items').length > 3) {
					options.set('items', options.get('items').slice(0, 3));
					alert('maximum items is 3, delete items to continue');
				}
			},
		},
		{
			name: 'backgroundColor',
			friendlyName: 'Background Color',
			type: 'color',
			defaultValue: defaultOptions.backgroundColor,
		},
		{
			name: 'borderColor',
			friendlyName: 'Border Color',
			type: 'color',
			defaultValue: defaultOptions.borderColor,
		},
		{
			name: 'textColor',
			friendlyName: 'Text Color',
			type: 'color',
			defaultValue: defaultOptions.textColor,
		},
		{
			name: 'textSizeMobile',
			friendlyName: 'Text Size Mobile',
			type: 'number',
			defaultValue: defaultOptions.textSizeMobile,
			helperText: 'The unit is REM. Only numbers are allowed',
		},
		{
			name: 'textSizeDesktop',
			friendlyName: 'Text Size Desktop',
			type: 'number',
			defaultValue: defaultOptions.textSizeDesktop,
			helperText: 'The unit is REM. Only numbers are allowed',
		},
	],
	image: getIconUrl(Icon.BRAGBAR),
});
